export default __webpack_public_path__ + "static/media/check-icon.0e461ba8.svg";